import React, { useEffect, useRef, useState } from "react";
import AlertPop from "./shared/AlertPop";
import DwellMarketText from "./shared/DwellMarketText";
import Pagination from "./shared/Pagination";
import SharedButton from "./shared/SharedButton";
import UserModel from "./shared/UserModel";
import { app_url } from "./shared/Utils";
import { useMatomo } from "@datapunt/matomo-tracker-react";

const User = ({ handlelogout, showLoader }) => {
  const islogged = localStorage.getItem("islogged");
  const filterRef = useRef();
  const timeout = useRef();
  const { trackPageView, trackEvent } = useMatomo();

  const [filter, setFilter] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currPage, setCurrPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [filteredUsers, setFilteredUsers] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [showModel, setShowModel] = useState(false);
  const [showAlert, setShowAlert] = useState(null);
  const [lastRole, setLastRole] = useState(null);

  const setAlert = (type, message = "") => {
    setShowAlert({ type, message });
  };

  const setPage = (pageType) => {
    trackEvent({ category: "Pagination Arrow Clicked", action: "click-event" });
    if (pageType) {
      setCurrPage(currPage + 1);
    } else {
      setCurrPage(currPage - 1);
    }
  };

  const handlePageSizeChange = (e) => {
    trackEvent({ category: "Page Size Changed", action: "change-event" });
    setCurrPage(0);
    setPageSize(e.target.value);
  };

  const handleAddUserClick = () => {
    trackEvent({ category: "Add User Button Clicked", action: "click-event" });
    setShowModel(true);
    setCurrentUser(null);
  };
  const closeModel = () => {
    setShowModel(false);
    setCurrentUser(null);
  };

  const handleEditUserClick = (user) => {
    trackEvent({ category: "Edit User Button Clicked", action: "click-event" });
    setShowModel(true);
    setCurrentUser(user);
    setLastRole(user.role);
  };

  const searchUser = () => {
    clearTimeout(timeout.current);

    timeout.current = setTimeout(() => {
      showLoader(true);
      fetch(`${app_url}account/getallusers/${currPage}/${pageSize}/${filter}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${islogged}`,
        },
      })
        .then((response) => {
          if (response.status === 401) {
            handlelogout();
          } else {
            return response.json();
          }
        })
        .then((data) => {
          showLoader(false);
          setFilteredUsers(data);
          setTotalPage(Math.ceil(data.count / pageSize));
        })
        .catch((error) => {
          console.error("Error:", error);
          showLoader(false);
        });
    }, 600);
  };

  const filterInput = (e) => {
    setFilter(e.target.value);
    setCurrPage(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAlert(null);
    }, 2000);
    return () => clearTimeout(timer);
  }, [showModel]);

  useEffect(() => {
    searchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, currPage, pageSize]);

  useEffect(() => {
    trackPageView({
      documentTitle: "User List Page",
      href: window.location.href,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {showAlert?.type === "success" ? (
        <AlertPop variant="success">
          <strong>
            <i className="fa fa-check alert-icon"></i> Success!{" "}
            {showAlert?.message}
          </strong>
        </AlertPop>
      ) : (
        ""
      )}

      {showAlert?.type === "danger" ? (
        <AlertPop variant="danger">
          <strong>
            <i className="fa fa-close alert-icon"></i> Error!{" "}
            {showAlert?.message}
          </strong>
        </AlertPop>
      ) : (
        ""
      )}
      <div className="header-heading">
        <div className="container">
          <DwellMarketText />
        </div>
      </div>
      <div className="mat-elevation-z8">
        <div className="dt-header">
          <div className="mat-form-field">
            <div className="mat-form-field-wrapper w-100">
              <div className="mat-form-field-flex border-bottom">
                <div className="mat-form-field-infix filtering">
                  <input
                    className="mat-input-element bd-bottom-black"
                    id="filterInput"
                    ref={filterRef}
                    onChange={filterInput}
                  />
                  <span
                    className={`mat-form-field-label-wrapper ${
                      filter !== "" ? "not-empty" : ""
                    }`}
                  >
                    <label
                      className="mat-form-field-label"
                      id="mat-form-field-label-1"
                      htmlFor="mat-input-0"
                    >
                      <span className="ng-star-inserted">Filter</span>
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="add-btn-group">
            <SharedButton
              id="add-user-btn"
              addClass="mat-focus-indicator mat-raised-button mat-button-base mat-primary"
              btnName="Add New User"
              handleClick={handleAddUserClick}
            />
          </div>
        </div>
        {filteredUsers?.users ? (
          <>
            <div className="user-table">
              <table
                className="mat-table cdk-table mat-sort dt-container"
                role="table"
              >
                <thead>
                  <tr role="row" className="mat-header-row cdk-header-row">
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Username
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Email
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      First Name
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Last Name
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Phone Number
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Client
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Active
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Role
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers?.users?.map((user) => {
                    return (
                      <tr key={user.id} role="row" className="mat-row cdk-row">
                        <td className="t-left word-break">{user.userName}</td>
                        <td className="t-left word-break">{user.email}</td>
                        <td className="t-left">{user.firstName}</td>
                        <td className="t-left">{user.lastName}</td>
                        <td className="t-left">{user.phoneNumber}</td>
                        <td className="t-left">{user.client}</td>
                        <td className="t-left">
                          {user.isActive ? "Yes" : "No"}
                        </td>
                        <td className="t-left ">{user.role}</td>
                        <td className="t-left ">
                          <SharedButton
                            id={`edituser-${user.id}`}
                            addClass="mat-focus-indicator mat-raised-button mat-button-base mat-primary"
                            btnName="Edit"
                            handleClick={() => handleEditUserClick(user)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination
              currPage={currPage}
              totalPage={totalPage}
              setPage={setPage}
              count={filteredUsers?.count}
              pageSize={pageSize}
              handlePageSizeChange={handlePageSizeChange}
            />
          </>
        ) : (
          ""
        )}
      </div>
      {showModel ? (
        <UserModel
          closeModel={closeModel}
          currentUser={currentUser}
          showLoader={showLoader}
          handlelogout={handlelogout}
          getAllUsers={searchUser}
          setAlert={setAlert}
          lastRole={lastRole}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default User;
